import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function TazminatHukuku() {
  const serviceFeatures = [
    {
      title: 'Maddi Tazminat',
      description: 'Maddi zararların tespiti ve tazminat talepleri',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      title: 'Manevi Tazminat',
      description: 'Manevi zararlar için tazminat davaları',
      icon: 'ri-heart-pulse-line'
    },
    {
      title: 'Trafik Kazası Tazminatları',
      description: 'Trafik kazasından kaynaklı tüm tazminat talepleri',
      icon: 'ri-car-line'
    },
    {
      title: 'İş Kazası Tazminatları',
      description: 'İş kazasından kaynaklı tüm tazminat talepleri',
      icon: 'ri-hard-hat-line'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-slate-900 text-white py-20">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/48c1a058165c7b08acf2db8c83a29b8b.jpg')`
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-slate-900/70"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="flex items-center mb-4 animate-fade-in-up">
              <Link to="/services" className="text-gray-300 hover:text-white transition-colors font-poppins font-light">
                Hizmetler
              </Link>
              <i className="ri-arrow-right-s-line mx-2 text-gray-400"></i>
              <span className="text-white font-poppins font-light">Tazminat Hukuku</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6 animate-fade-in-up font-poppins" style={{ animationDelay: '0.1s' }}>
              Tazminat Hukuku
            </h1>
            
            <p className="text-xl text-gray-200 leading-relaxed animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.2s' }}>
              Maddi ve manevi tazminat davaları, trafik ve iş kazası tazminatları konularında 
              uzman hukuki danışmanlık ve temsil hizmetleri sunuyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Service Features */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 animate-fade-in-up font-poppins">
              Tazminat Alanlarımız
            </h2>
            <div className="w-16 h-0.5 bg-slate-900 mx-auto mb-6"></div>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.1s' }}>
              Tazminat hukuku alanında kapsamlı hizmetler
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {serviceFeatures.map((feature, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg border border-gray-100 p-8 hover:shadow-xl transition-all duration-300 animate-fade-in-up hover-lift"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-16 h-16 bg-slate-900 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4 font-poppins">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed font-poppins font-light">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Detailed Content */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-slate-900 mb-8 animate-fade-in-up font-poppins">
            Tazminat Hukuku Hizmetlerimiz
          </h2>
          
          <div className="space-y-6 text-slate-600 leading-relaxed font-poppins font-light">
            <p className="animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
              Tazminat hukuku alanında uzman kadromuzla, müvekkillerimizin uğradığı maddi ve 
              manevi zararların tazmin edilmesi için kapsamlı hukuki hizmetler sunuyoruz. 
              Trafik kazaları, iş kazaları ve diğer zarar verici olaylar sonucunda ortaya 
              çıkan tazminat taleplerinde profesyonel destek sağlıyoruz.
            </p>
            
            <p className="animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              Maddi tazminat hesaplamalarında uzman bilirkişilerle çalışarak, müvekkillerimizin 
              gerçek zararlarının tespit edilmesini ve tam olarak tazmin edilmesini sağlıyoruz. 
              Manevi tazminat davalarında ise içtihatları takip ederek en uygun miktarların 
              talep edilmesini sağlıyoruz.
            </p>
            
            <p className="animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
              Sigorta şirketleriyle müzakere süreçlerinde müvekkillerimizi temsil ediyor, 
              gerektiğinde dava yoluyla haklarının korunmasını sağlıyoruz. Tazminat 
              davalarında deneyimli kadromuzla en iyi sonucu elde etmeye çalışıyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4 animate-fade-in-up font-poppins">
            Tazminat Danışmanlığı
          </h2>
          <p className="text-lg text-gray-200 mb-8 animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.1s' }}>
            Haklarınızı koruyun, tazminat talebinizi değerlendirin
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <button className="bg-white text-slate-900 px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors font-poppins font-semibold whitespace-nowrap cursor-pointer">
              Tazminat Hesaplama
            </button>
            <button className="border border-white text-white px-8 py-3 rounded-lg hover:bg-white hover:text-slate-900 transition-colors font-poppins font-semibold whitespace-nowrap cursor-pointer">
              Hukuki Danışmanlık
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}